export default "__VITE_PUBLIC_ASSET__1a78eda4__"